<template>
  <div>
    <div class="c_page-title">
      <div>订单商品断货日志</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.order_sn"
                    placeholder="订单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="选择城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pgid" placeholder="代采组">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="val in pgOption"
                      :key="val.value"
                      :label="val.label"
                      :value="val.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.pg_member_id" placeholder="代采员">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="val in memberOption"
                      :key="val.value"
                      :label="val.label"
                      :value="val.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-input
                    v-model="form.operator"
                    placeholder="操作人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.type" placeholder="操作来源">
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in actionOption"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作时间">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="用户订单生成时间">
                  <el-date-picker
                    v-model="form.order_add_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-select v-model="form.is_offer" placeholder="是否特价商品">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="info"
            size="mini"
            @click="dialogtxt = true"
          >
            断货来源说明</el-button
          >
          <el-button style="" type="success" size="mini" @click="output()">
            导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="order_sn"
              label="订单号"
              show-overflow-tooltip
              align="center"
              width="140px"
            >
              <template slot-scope="{ row }">
                <span @click="handleCopy(row.order_sn)">{{
                  row.order_sn
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="order_add_time"
              label="用户订单生成时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="is_offer_text"
              label="是否特价商品"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.goods_img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
              width="120px"
            >
              <template slot-scope="{ row }">
                <span @click="handleCopy(row.goods_no)">{{
                  row.goods_no
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="nums"
              label="数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="type_txt"
              label="操作来源"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="note"
              label="断货原因"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator"
              label="操作人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator_time"
              label="断货时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :page-sizes="[10, 50, 100]"
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper,sizes"
            :total="resData.total"
            :page-size="10"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="操作来源解释：" :visible.sync="dialogtxt" width="40%">
      <div>代采断货：急救箱被清空导致用户订单断货</div>
      <div>用户断货：用户排单时间超过“锁定排单天数”后，用户自主取消</div>
      <div>后台断货：原后台【排单情况列表】对订单商品断货</div>
      <div>客服断货：原后台【用户订单列表详情】对订单商品断货</div>
      <div>
        系统断货-数量不足自动断：每天早上对“用户订单件数”减去“有机会回货数量”（欠货＋待开单-转抵扣-转退款-核销）的溢出部分进行断货
      </div>
      <div>
        系统断货-超时自动断货：没有获取到“预计回货天数”，用户排单时间超过系统规定时间，自动断货；
      </div>
      <div>
        系统断货-排单过期断货：获取到“预计回货天数”，且用户排单时间超过系统规定时间，自动断货；
      </div>
      <div>系统断货：除了以上7种情况外的断货；</div>
      <div>恢复不断货：商城后台【排单情况列表】恢复不断货；</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogtxt = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.fetchData();
      vm.fetchPg();
      vm.fetchPgMember();
    });
  },
  data() {
    return {
      resData: { list: [], count: 0 },
      form: {
        page: 1,
        page_size: 10,
        source: "",
        city: [],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Log/orderStopLogList",
      status: "",
      curPage: 1,
      market_id: "",
      pgOption: [],
      citys: CITY,
      memberOption: [],
      filterFold: false,
      dialogtxt: false,
      actionOption: [
        { key: 1, label: "用户断货" },
        { key: 2, label: "后台断货" },
        { key: 3, label: "客服断货" },
        { key: 4, label: "系统断货" },
        { key: 5, label: "排单" },
        { key: 6, label: "系统断货-数量不足自动断" },
        { key: 7, label: "系统断货-超时自动断" },
        { key: 8, label: "系统断货-排单过期断货" },
        { key: 9, label: "代采断货" },
        { key: 10, label: "爆版断货" },
        { key: 11, label: "用户要求取消待配" },
        { key: 12, label: "系统断货-高风险订单" },
        { key: 13, label: "人工批量断货" },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  methods: {
    output(type) {
      this.form.is_excel = 1;
      this.$http
        .post("/erp/Log/orderStopLogList", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    fetchData(showLoading) {
      this.form.is_excel = 0;
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchPg() {
      this.$http.post("/erp/Common/selectPg").then((res) => {
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.pgOption = res.data.data;
      });
    },
    fetchPgMember() {
      this.$http.post("/erp/Common/getPurchaseMember").then((res) => {
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.memberOption = res.data.data;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.form.spid = [];
      val.map((v) => {
        this.form.spid.push(v.supply_id);
      });
      this.multipleSelection = val;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData();
    },
    search() {
      this.form.is_excel = 0;
      this.form.page = 1;
      this.fetchData();
    },
    handleCopy(text) {
      this.$copyText(text).then(() => {
        this.$message.info("复制成功！");
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/log/OrderStopLogList.vue